import React, { useState, useEffect } from 'react';
import { PropTypes, richTextPropTypes } from 'prop-types';
import { getStorageValue, setStorageValue } from '../../utils/session-storage';
import Banner from './banner';

// Styles
import { StickyWrapper } from './styles';

const AlertBanner = ({ bannerTitle, text, contentfulId }) => {
  const [showBanner, setShowBanner] = useState(false);

  const handleClick = () => {
    setStorageValue('last seen', contentfulId, 'alertBanner', 'local');
    setShowBanner(false);
  };

  const bannerStorageValue = getStorageValue(
    'last seen',
    'alertBanner',
    'local'
  );

  useEffect(() => {
    // #ccc-notify is the intial cookie banner along the bottom
    if (!document.getElementById('ccc-notify')) {
      setShowBanner(bannerStorageValue !== contentfulId);
      return;
    }

    // Observes the Cookie Control parent div (#ccc) for DOM changes
    // Loops through the list of MutationRecord to check if the notify banner (#ccc-notify)
    // was removed from the DOM. If so, the Alert banner is displayed and MutationObserver stopped.

    const observedNode = document.getElementById('ccc');
    const observer = new MutationObserver((entries) => {
      entries.forEach((entry) => {
        entry.removedNodes.forEach((removedNode) => {
          if (removedNode.id === 'ccc-notify') {
            setShowBanner(!bannerStorageValue);
            observer.disconnect();
          }
        });
      });
    });

    // subtree - extends monitoring to the entire subtree of nodes rooted at 'observedNode'
    // childList - enables the tracking of removedNodes
    observer.observe(observedNode, { subtree: true, childList: true });
  }, [bannerStorageValue, contentfulId]);

  return (
    showBanner && (
      <StickyWrapper>
        <Banner bannerTitle={bannerTitle} text={text} handler={handleClick} />
      </StickyWrapper>
    )
  );
};

AlertBanner.propTypes = {
  bannerTitle: PropTypes.string.isRequired,
  text: PropTypes.shape(richTextPropTypes).isRequired,
  contentfulId: PropTypes.string.isRequired,
};

export default AlertBanner;
